import type { LabelHTMLAttributes } from 'react';
import { cva, type RecipeVariantProps } from '../../styled-system/css';

export const labelRecipe = cva({
  base: {
    fontSize: 'md',
    fontWeight: 'bold',
    color: 'main.text.2',
    background: 'transparent',
  },
  variants: {
    size: {
      sm: {
        fontSize: 'sm',
      },
      md: {
        fontSize: 'md',
      }
    }
  },
  defaultVariants: {
    size: 'md',
  }
});

type LabelVariants = RecipeVariantProps<typeof labelRecipe>;

export const Label = ({
  children,
  ...props
}: LabelHTMLAttributes<HTMLLabelElement> & LabelVariants) => {
  return (
    <label
      {...props}
      className={labelRecipe()}
    >
      {children}
    </label>
  );
};
